import { createSlice } from '@reduxjs/toolkit'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import { getUnique, keyBy } from '../../../../../helpers/common'
import {
  register,
  syncInitialState,
} from '../../../../../helpers/reducerRegistry'
import { changeValueWithDot } from '../../../../../helpers/value'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { CURRENCY, UNIT } from '../../../../../utils/currency'
import { MAIN_SCREEN, SCREEN, TYPE_ITEM_SETTING } from '../../../constant'
import { DEFAULT_INDUSTRY } from '../../../helper/companyAnalysis/industryAnalysis'
import { COVER_PAGE_ID, dataSelectCompanyType, mainTabs } from '../constant'
import {
  changeValueAllPanel,
  convertParamSettingFs,
  copyObj,
  getCount,
  handlePortfolioData,
} from '../helper'
import {
  getAllPortfolio,
  getIndicators,
  getTemplateThunk,
  searchCompanyThunk,
} from './thunk'

export const KEY_LOADING = {
  COMPANY: 'company',
  DETAIL_TEMPLATE: 'detailTemplate',
  INDICATOR: 'indicator',
  PORTFOLIO: 'portfolio',
}

const initialState = {
  panelById: {},
  panelId: [],
  templateName: '',
  defaultTemplate: {
    templateId: '',
    templateName: '',
    panelId: [],
    panelById: {},
    companyType: dataSelectCompanyType[0].value,
    reportTitle: '',
    isHasReportSubtitle: false,
    reportSubtitle: '',
    isHasCompanyName: false,
    isHasPortName: false,
  },
  activePanel: COVER_PAGE_ID,
  mainScreen: mainTabs[0].value,
  companyType: dataSelectCompanyType[0].value,
  loading: {
    [KEY_LOADING.COMPANY]: false,
    [KEY_LOADING.DETAIL_TEMPLATE]: false,
    [KEY_LOADING.INDICATOR]: false,
    [KEY_LOADING.PORTFOLIO]: false,
  },
  companies: [],
  indicatorById: {},
  count: {},
  reportTitle: '',
  isHasReportSubtitle: false,
  reportSubtitle: '',
  isHasCompanyName: false,
  isHasPortName: false,
  allPortfolio: [],
  currentPortfolio: undefined,
  namePortfolioActive: '',
  settingReport: {
    yearReport: undefined,
    currencyUnitFs: [],
    settingFs: {},
  },
  dataKeepSetting: null,
  isKeepingSetting: false,
}

const name = 'dynamicReport/preferenceSetting/detailTemplate'
const persistKeys = [
  'panelById',
  'panelId',
  'templateName',
  'defaultTemplate',
  'activePanel',
  'mainScreen',
  'companyType',
  'count',
  'reportTitle',
  'isHasReportSubtitle',
  'reportSubtitle',
  'currentPortfolio',
  'settingReport',
  'isHasCompanyName',
  'isHasPortName',
  'namePortfolioActive',
]

const slice = createSlice({
  name,
  initialState: syncInitialState({ name, initialState, persistKeys }),
  reducers: {
    resetFullStoreDetailTemplate() {
      return initialState
    },
    addPanel: (state, action) => {
      const panel = copyObj({
        ...action.payload,
        id: getUnique(),
      })

      if (
        panel.screen ===
          SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS &&
        panel.setting &&
        state.settingReport.yearReport
      ) {
        panel.setting.year = state.settingReport.yearReport[0]
      }

      let panelSameScreen
      if (panel.type === TYPE_ITEM_SETTING.PANEL) {
        const panelSameScreenId = state.panelId.find(
          (id) => state.panelById[id].screen === panel.screen,
        )
        if (panelSameScreenId) {
          panelSameScreen = state.panelById[panelSameScreenId]
        }
      }

      state.panelById[panel.id] = panel
      state.panelId.push(panel.id)

      if (panelSameScreen) {
        changeValueAllPanel(state.panelById, panelSameScreen)
      } else {
        state.panelById[panel.id] = changeValueWithDot(
          state.panelById[panel.id],
          `setting.${DEFAULT_INDUSTRY}`,
          action.payload.defaultIndustryId,
        )
      }

      if (!state.defaultTemplate.panelById[panel.id]) {
        state.defaultTemplate.panelById[panel.id] = panel
      }

      state.count = getCount(state.panelId, state.panelById)
    },
    changeName: (state, action) => {
      state.templateName = action.payload
    },
    addDefault: (state, action) => {
      const {
        panelsSelected,
        templateName,
        templateId,
        companyType,
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      } = action.payload

      const panelId = panelsSelected.map((panel) => panel.id)
      const panelById = keyBy(panelsSelected, 'id')

      state.defaultTemplate = {
        templateId,
        templateName,
        panelId,
        panelById,
        companyType,
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      }
    },
    changeId: (state, action) => {
      state.panelId = action.payload
    },
    removePanel: (state, action) => {
      const removeId = action.payload
      state.panelId = state.panelId.filter((id) => id !== removeId)
      delete state.panelById[removeId]
      state.count = getCount(state.panelId, state.panelById)
    },
    resetDefault: (state) => {
      state.panelId = state.defaultTemplate.panelId
      state.panelById = {}
      state.panelId.forEach((id) => {
        state.panelById[id] = state.defaultTemplate.panelById[id]
      })
      state.templateName = state.defaultTemplate.templateName
      state.companyType = state.defaultTemplate.companyType
      state.activePanel = null
      state.reportTitle = state.defaultTemplate.reportTitle
      state.isHasReportSubtitle = state.defaultTemplate.isHasReportSubtitle
      state.reportSubtitle = state.defaultTemplate.reportSubtitle
      state.isHasCompanyName = state.defaultTemplate.isHasCompanyName
      state.isHasPortName = state.defaultTemplate.isHasPortName

      state.count = getCount(state.panelId, state.panelById)
    },
    setBlankTemplate: (state) => {
      state.panelById = initialState.panelById
      state.panelId = initialState.panelId
      state.templateName = initialState.templateName
      state.companyType = initialState.companyType
      state.reportTitle = initialState.reportTitle
      state.isHasReportSubtitle = initialState.isHasReportSubtitle
      state.reportSubtitle = initialState.reportSubtitle
      state.activePanel = initialState.activePanel
      state.count = initialState.count
      state.isHasCompanyName = initialState.isHasCompanyName
      state.isHasPortName = initialState.isHasPortName
    },
    changeActivePanel: (state, action) => {
      const { id, companyType } = action.payload
      if (id !== state.activePanel) {
        const panelActive = state.panelById[state.activePanel]
        if (
          companyType === COMPANY_TYPES.CORPORATE &&
          panelActive?.screen ===
            SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS &&
          !panelActive?.setting?.[DEFAULT_INDUSTRY]
        ) {
          EventEmitter.dispatch(SHOW_POPUP_ERROR, {
            title: 'common.WARNING',
            messages: [
              <Translate value="dynamicReport.WARNING_INDUSTRY_ANALYSIS" />,
            ],
            button: 'dynamicReport.OK',
          })
        } else {
          state.activePanel = id
        }
      }
    },
    changeValue: (state, action) => {
      const { id, key, value } = action.payload
      state.panelById[id] = changeValueWithDot(state.panelById[id], key, value)
      changeValueAllPanel(state.panelById, state.panelById[id])
    },
    changeMainScreen: (state, action) => {
      state.mainScreen = action.payload
    },
    changeCompanyType: (state, action) => {
      if (state.companyType !== action.payload) {
        state.companyType = action.payload
        state.panelId = state.panelId.filter((id) => {
          const { screen } = state.panelById[id]
          if (
            [
              SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
              SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
              SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_PERFORMANCE_SCORE,
              SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS,
            ].includes(screen)
          ) {
            delete state.panelById[id]
            return false
          }
          return true
        })
        state.count = getCount(state.panelId, state.panelById)
      }
    },
    removeMainScreenPanel: (state, action) => {
      state.panelId = state.panelId.filter((id) => {
        const { mainScreen } = state.panelById[id]
        if (mainScreen === action.payload) {
          delete state.panelById[id]
          return false
        }
        return true
      })
      state.count = getCount(state.panelId, state.panelById)
    },
    changeReportTitle: (state, action) => {
      state.reportTitle = action.payload
    },
    changeIsHasReportSubtitle: (state, action) => {
      state.isHasReportSubtitle = action.payload
    },
    changeReportSubtitle: (state, action) => {
      state.reportSubtitle = action.payload
    },
    changeIsHasCompanyName: (state, action) => {
      state.isHasCompanyName = action.payload
    },
    changeIsHasPortName: (state, action) => {
      state.isHasPortName = action.payload
    },
    changeCurrentPortfolio: (state, action) => {
      state.currentPortfolio = action.payload
    },
    changeNamePortfolioActive: (state, action) => {
      state.namePortfolioActive = action.payload
    },
    changeLoadingDetailTemplate: (state, action) => {
      state.loading[KEY_LOADING.DETAIL_TEMPLATE] = action.payload
    },
    setNullYearFinancialAnalysis: (state) => {
      state.settingReport.yearReport = undefined
      state.panelId.forEach((id) => {
        const panel = state.panelById[id]
        if (
          panel.screen ===
            SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS &&
          state.panelById[id].setting
        ) {
          state.panelById[id].setting.year = null
          state.defaultTemplate.panelById[id] = changeValueWithDot(
            state.defaultTemplate.panelById[id] || {},
            'setting.year',
            null,
          )
        }
      })
    },
    setDefaultYearFinancialAnalysis: (state, action) => {
      state.settingReport.settingFs = convertParamSettingFs(action.payload)

      const newYearReport = [
        ...action.payload.map((item) => item.year),
      ].reverse()

      if (
        JSON.stringify(state.settingReport.yearReport || []) !==
        JSON.stringify(newYearReport || [])
      ) {
        state.settingReport.yearReport = newYearReport

        const lastYear = state.settingReport.yearReport[0]

        state.panelId.forEach((id) => {
          const panel = state.panelById[id]
          if (
            panel.screen ===
              SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS &&
            state.panelById[id].setting
          ) {
            if (!state.panelById[id].setting.year || !state.isKeepingSetting) {
              state.panelById[id].setting.year = lastYear
              state.defaultTemplate.panelById[id] = changeValueWithDot(
                state.defaultTemplate.panelById[id] || {},
                'setting.year',
                lastYear,
              )
            }
          }
        })
      }

      state.isKeepingSetting = false
    },
    resetDefaultCoverPage: (state) => {
      state.reportTitle = state.defaultTemplate.reportTitle
      state.isHasReportSubtitle = state.defaultTemplate.isHasReportSubtitle
      state.reportSubtitle = state.defaultTemplate.reportSubtitle
      state.isHasCompanyName = state.defaultTemplate.isHasCompanyName
      state.isHasPortName = state.defaultTemplate.isHasPortName
    },
    resetSettingPanel: (state, action) => {
      const id = action.payload
      state.panelById[id] = state.defaultTemplate.panelById[id]
      changeValueAllPanel(state.panelById, state.panelById[id])
    },
    addCurrencyUnitFs: (state, action) => {
      state.settingReport.currencyUnitFs.push(action.payload)
    },
    resetCurrencyUnitFs: (state) => {
      state.settingReport.currencyUnitFs = [
        { currency: CURRENCY.VND, unit: UNIT.SINGLE.unitKey },
      ]
    },
    removeCurrencyUnitFs: (state, action) => {
      state.settingReport.currencyUnitFs.splice(action.payload, 1)
    },
    changeCurrencyUnitFs: (state, action) => {
      const { index, key, value } = action.payload
      state.settingReport.currencyUnitFs[index][key] = value
    },
    changeAllCurrencyUnitFs: (state, action) => {
      state.settingReport.currencyUnitFs = action.payload
    },
    changeSettingFs: (state, action) => {
      state.settingReport.settingFs = action.payload
    },
    changeDataKeepSetting: (state, action) => {
      state.dataKeepSetting = action.payload
    },
    addDataKeepSetting: (state, action) => {
      const panels = action.payload

      const panelId = panels.map((panel) => panel.id)
      const panelById = keyBy(panels, 'id')

      state.panelId = panelId
      state.panelById = panelById
      state.templateName = ''

      state.defaultTemplate = {
        templateId: '',
        templateName: '',
        panelId,
        panelById,
        reportTitle: '',
        isHasReportSubtitle: false,
        reportSubtitle: '',
        companyType: state.companyType,
        isHasCompanyName: false,
        isHasPortName: false,
      }

      state.count = getCount(state.panelId, state.panelById)
    },
    changeIsKeepingSetting: (state, action) => {
      state.isKeepingSetting = action.payload
    },
  },
  extraReducers: (builder) => {
    // get template
    builder.addCase(searchCompanyThunk.pending, (state) => {
      state.loading[KEY_LOADING.COMPANY] = true
    })
    builder.addCase(searchCompanyThunk.fulfilled, (state, action) => {
      state.companies = action.payload

      state.loading[KEY_LOADING.COMPANY] = false
    })
    builder.addCase(searchCompanyThunk.rejected, (state, action) => {
      state.loading[KEY_LOADING.COMPANY] = action.payload
    })

    builder.addCase(getTemplateThunk.pending, (state) => {
      state.panelById = initialState.panelById
      state.panelId = initialState.panelId
      state.templateName = initialState.templateName
      state.companyType = initialState.companyType
      state.activePanel = initialState.activePanel
      state.count = initialState.count
      state.reportTitle = initialState.reportTitle
      state.isHasReportSubtitle = initialState.isHasReportSubtitle
      state.reportSubtitle = initialState.reportSubtitle
      state.loading[KEY_LOADING.DETAIL_TEMPLATE] = true
      state.isHasCompanyName = initialState.isHasCompanyName
      state.isHasPortName = initialState.isHasPortName
    })
    builder.addCase(getTemplateThunk.fulfilled, (state, action) => {
      const template = action.payload
      const templateName = template.templateName
      const companyType = template.companyType
      const templateData = JSON.parse(template.templateData)
      const newTemplateData = {
        ...templateData,
        panels: templateData.panels.filter((panel) => panel.screen !== 'score'),
        //Thêm xử lý bỏ các component báo cáo cũ đã bỏ khỏi hệ thống
      }
      const panelById = keyBy(newTemplateData.panels, 'id')
      const panelId = newTemplateData.panels.map((panel) => panel.id)

      state.defaultTemplate = {
        templateId: template.id,
        templateName,
        panelId,
        panelById,
        companyType,
      }

      state.panelById = panelById
      state.panelId = panelId
      state.templateName = templateName
      state.companyType = companyType
      state.reportTitle = templateData.reportTitle
      state.isHasReportSubtitle = templateData.isHasReportSubtitle
      state.reportSubtitle = templateData.reportSubtitle
      state.count = getCount(panelId, panelById)
      state.isHasCompanyName = templateData.isHasCompanyName
      state.isHasPortName = templateData.isHasPortName
      state.loading[KEY_LOADING.DETAIL_TEMPLATE] = false
    })
    builder.addCase(getTemplateThunk.rejected, (state) => {
      state.loading[KEY_LOADING.DETAIL_TEMPLATE] = false
    })
    // get indicator panel
    builder.addCase(getIndicators.pending, (state) => {
      state.loading[KEY_LOADING.INDICATOR] = true
    })
    builder.addCase(getIndicators.fulfilled, (state, action) => {
      state.indicatorById = keyBy(action.payload, 'ratioCode')
      state.loading[KEY_LOADING.INDICATOR] = false
    })
    builder.addCase(getIndicators.rejected, (state, action) => {
      state.loading[KEY_LOADING.INDICATOR] = action.payload
    })
    // get all portfolio
    builder.addCase(getAllPortfolio.pending, (state) => {
      state.loading[KEY_LOADING.PORTFOLIO] = true
    })
    builder.addCase(getAllPortfolio.fulfilled, (state, action) => {
      state.allPortfolio = handlePortfolioData(action.payload)
      state.loading[KEY_LOADING.PORTFOLIO] = false
    })
    builder.addCase(getAllPortfolio.rejected, (state, action) => {
      state.loading[KEY_LOADING.PORTFOLIO] = action.payload
    })
  },
})

export const {
  addPanel,
  changeName,
  addDefault,
  changeId,
  removePanel,
  resetDefault,
  setBlankTemplate,
  changeActivePanel,
  changeValue,
  changeMainScreen,
  changeCompanyType,
  resetFullStoreDetailTemplate,
  removeMainScreenPanel,
  changeReportTitle,
  changeIsHasReportSubtitle,
  changeReportSubtitle,
  changeCurrentPortfolio,
  changeLoadingDetailTemplate,
  setNullYearFinancialAnalysis,
  setDefaultYearFinancialAnalysis,
  resetDefaultCoverPage,
  resetSettingPanel,
  addCurrencyUnitFs,
  removeCurrencyUnitFs,
  changeCurrencyUnitFs,
  resetCurrencyUnitFs,
  changeAllCurrencyUnitFs,
  changeSettingFs,
  changeDataKeepSetting,
  addDataKeepSetting,
  changeIsKeepingSetting,
  changeIsHasCompanyName,
  changeIsHasPortName,
  changeNamePortfolioActive,
} = slice.actions

export const selectLoading = (key) => (state) => state[slice.name].loading[key]

export const selectPanelId = (state) => state[slice.name].panelId

export const selectPanelById = (state) => state[slice.name].panelById

export const selectDetailPanel = (id) => (state) =>
  state[slice.name].panelById[id]

export const selectName = (state) => state[slice.name].templateName

export const selectActivePanel = (state) => state[slice.name].activePanel

export const selectDefaultTemplate = (state) =>
  state[slice.name].defaultTemplate

export const selectMainScreen = (state) => state[slice.name].mainScreen

export const selectCompanyType = (state) => state[slice.name].companyType

export const selectCompanies = (state) => state[slice.name].companies

export const selectCount = (id) => (state) => state[slice.name].count[id]

export const selectIndicatorById = (state) => state[slice.name].indicatorById

export const selectReportTitle = (state) => state[slice.name].reportTitle

export const selectIsHasReportSubtitle = (state) =>
  state[slice.name].isHasReportSubtitle

export const selectReportSubtitle = (state) => state[slice.name].reportSubtitle

export const selectIsHasCompanyName = (state) =>
  state[slice.name].isHasCompanyName

export const selectIsHasPortName = (state) => state[slice.name].isHasPortName

export const selectNamePortActive = (state) =>
  state[slice.name].namePortfolioActive

export const selectAllPortfolio = (state) => state[slice.name].allPortfolio

export const selectCurrentPortfolio = (state) =>
  state[slice.name].currentPortfolio

export const selectState = (state) => state[slice.name]

export const selectYearReport = (state) =>
  state[slice.name].settingReport.yearReport

export const selectCurrencyUnitFs = (state) =>
  state[slice.name].settingReport.currencyUnitFs

export const selectSettingFs = (state) =>
  state[slice.name].settingReport.settingFs

export const selectDataKeepSetting = (state) =>
  state[slice.name].dataKeepSetting

export const selectIsKeepingSetting = (state) =>
  state[slice.name].isKeepingSetting

register(slice.name, slice.reducer, persistKeys)
